<!-- Define our page card. -->
<mat-card class="mat-page-card">

  <!-- Define the header of our page card. -->
  <mat-card-header>

    <!-- Give our page an icon. -->
    <mat-icon mat-card-avatar color="icon-orange">domain</mat-icon>

    <!-- Give our page a main title. -->
    <mat-card-title>
      PEO PrismHR API Credential Test
    </mat-card-title>

    <!-- Give our page a very short description. -->
    <mat-card-subtitle>
      Below is a table of the existing PEO API Credentials which can
      be tested directly against the PrismHR API from this page.
    </mat-card-subtitle>
  </mat-card-header>

  <!-- Define the content of our page card. -->
  <mat-card-content>
    <div>

      <div class="table-controls">

        <!-- Table Filter -->
        <mat-form-field>
          <mat-label>Search the table below</mat-label>
          <input matInput [(ngModel)]="filterInput" (keyup)="filterTable($event)" placeholder="Vensure" type="text">

          <button *ngIf="filterInput" mat-icon-button matSuffix matTooltip="Clear table filter."
                  aria-label="Clear PEO API Credentials table filter." (click)="clearFilter()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>

        <!-- Paginator -->
        <mat-paginator [pageSizeOptions]="[10, 25, 50, 75, 100, 250, 500, 1000, 5000, 10000]"
                       aria-label="Select page size of PEO table."></mat-paginator>
      </div>

      <table mat-table matSort [dataSource]="credentialDataSource" class="mat-elevation-z8">

        <!-- PEO ID Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Peo ID</th>
          <td mat-cell *matCellDef="let element;">
            <span>{{ element.peoId }}</span>
          </td>
          <td mat-footer-cell *matFooterCellDef>&nbsp;</td>
        </ng-container>

        <!-- Username Column -->
        <ng-container matColumnDef="username">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>PrismHR API Username</th>
          <td mat-cell *matCellDef="let element">{{ element.username }}</td>
          <td mat-footer-cell *matFooterCellDef>&nbsp;</td>
        </ng-container>

        <!-- Password Column -->
        <ng-container matColumnDef="password">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>PrismHR API Password</th>
          <td mat-cell *matCellDef="let element" class="align-center">
            <span *ngIf="!credentialToggles[element.peoId].hidePassword">{{ element.password }}</span>
            <span *ngIf="credentialToggles[element.peoId].hidePassword">{{ '*'.repeat(element.password.length) }}</span>
          </td>
          <td mat-footer-cell *matFooterCellDef>&nbsp;</td>
        </ng-container>

        <!-- Url Column -->
        <ng-container matColumnDef="url">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>PrismHR API URL</th>
          <td mat-cell *matCellDef="let element">
            <a [href]="element.url" target="_blank">{{ element.url }}</a>
          </td>
          <td mat-footer-cell *matFooterCellDef>&nbsp;</td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="_actions">
          <th mat-header-cell *matHeaderCellDef>

            <!-- Toggle All Password Visibility -->
            <button mat-icon-button matTooltip="Toggle password visibility."
                    aria-label="Toggle password visibility." (click)="togglePasswordVisibility()">
              <mat-icon *ngIf="hidePasswords">visibility</mat-icon>
              <mat-icon *ngIf="!hidePasswords">visibility_off</mat-icon>
            </button>

            <!-- Test All Credentials -->
            <button mat-icon-button (click)="testCredential()"
                    [color]="tested ? testedSuccessfully ? 'icon-green' : 'icon-red' : 'icon-orange'"
                    [disabled]="testing" matTooltip="Test the API Credentials directly against the PrismHR API.">
              <mat-icon *ngIf="!testing && !tested">api</mat-icon>
              <mat-icon *ngIf="!testing && tested && testedSuccessfully">check</mat-icon>
              <mat-icon *ngIf="!testing && tested && !testedSuccessfully">report</mat-icon>
              <mat-icon *ngIf="testing">
                <mat-spinner color="warn" diameter="20"></mat-spinner>
              </mat-icon>
            </button>

            <!-- Download Report CSV -->
            <button mat-icon-button (click)="downloadReport()"
                    [color]="!testing && tested ? 'icon-green' : 'icon-slate'"
                    [disabled]="!tested || testing" matTooltip="Download a CSV report of the API Credential tests.">
              <mat-icon *ngIf="!testing && tested">file_download</mat-icon>
              <mat-icon *ngIf="testing || !tested">file_download_off</mat-icon>
            </button>
          </th>
          <td mat-cell *matCellDef="let element" class="align-end">

            <!-- Toggle Credential Password Visibility -->
            <button mat-icon-button matTooltip="Toggle password visibility."
                    aria-label="Toggle password visibility." (click)="togglePasswordVisibility(element.peoId)"
                    class="align-end">
              <mat-icon *ngIf="credentialToggles[element.peoId].hidePassword">visibility</mat-icon>
              <mat-icon *ngIf="!credentialToggles[element.peoId].hidePassword">visibility_off</mat-icon>
            </button>

            <!-- Test Credential -->
            <button mat-icon-button (click)="testCredential(element.peoId)"
                    [color]="credentialToggles[element.peoId].tested ? credentialToggles[element.peoId].testedSuccessfully ? 'icon-green' : 'icon-red' : 'icon-orange'"
                    matTooltip="Test the API Credential directly against the PrismHR API.">
              <mat-icon *ngIf="!credentialToggles[element.peoId].testing && !credentialToggles[element.peoId].tested">
                api
              </mat-icon>
              <mat-icon
                *ngIf="!credentialToggles[element.peoId].testing && credentialToggles[element.peoId].tested && credentialToggles[element.peoId].testedSuccessfully">
                check
              </mat-icon>
              <mat-icon
                *ngIf="!credentialToggles[element.peoId].testing && credentialToggles[element.peoId].tested && !credentialToggles[element.peoId].testedSuccessfully">
                report
              </mat-icon>
              <mat-icon *ngIf="credentialToggles[element.peoId].testing">
                <mat-spinner color="warn" diameter="20"></mat-spinner>
              </mat-icon>
            </button>
          </td>
          <td mat-footer-cell *matFooterCellDef class="align-end">&nbsp;</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
        <tr mat-footer-row *matFooterRowDef="tableColumns"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" *ngIf="!!filterInput && !loading" colspan="5" style="text-align: center;">No PEO API
            Credentials found matching "{{ filterInput }}".
          </td>
          <td class="mat-cell" *ngIf="loading" colspan="5">
            <span style="display: flex; justify-content: center; align-items: center; width: 100%;">
              <mat-spinner color="warn" diameter="20"></mat-spinner>
              &nbsp;
              Loading
            </span>
          </td>
        </tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>
